export default "__VITE_ASSET__C4k0_9la__"